import useAuth from '@/hooks/useAuth';
import AccountPopover from '@/layouts/dashboard/header/AccountPopover';
import { segmentEventPayload, showLoginPopupAtom, userInputEmailAtom } from '@/modules/editor-v2/Atoms';
import GetAppLinkByScan from '@/modules/home/GetAppLinkByScan';
import { NeedHelp } from '@/modules/home/needHelp';
import { EventTrackName } from '@/modules/segment-event-tracking/constant';
import { TrackWebappEvent } from '@/modules/segment-event-tracking/segmentEventTracking';
import { Badge } from '@mui/material';
import { Loader } from '@/modules/editor-v2/MiddleSection/EditorTopToolBar';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import API_SERVICE from "src/utils/axios";
import Help from './help.svg';
import CustomizedButton from "@/modules/ui-elements/CustomizedButton";
import Phone from './phone.svg';
import styles from './styles.module.css';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import ErrorBoundary from '@/modules/canvas/errorBoundry';
import { ICONS } from '@/modules/ui-elements/Icon';
import {InfographicsSelector} from '@/modules/editor-v2/InforgraphicsHeader/InfographicSelector';

export default function Header() {

    const setLoginPopupAtom = useSetAtom(showLoginPopupAtom);
    const getSegmentPayloadAtom = useAtomValue(segmentEventPayload);
    const {user,isAuthenticated} = useAuth();
    const [isGetAppPopUpOpen, setIsGetAppPopUpOpen] = useState(false);
    const [notification, setNotification] = useState(0);
    const [help, setHelp] = useState(false);

    const strapiData:any = useSelector<any>(state=>state?.strapi?.entireStrapiData?.StudioHeaderText?.StudioHeaderText);
    const webStrapiData:any = useSelector<any>(state=>state?.strapi?.entireStrapiData?.WebappHomepageV22?.WebappHomepageV22);
    const searchParams = useSearchParams();
    const email = searchParams.get('email');
    const router = useRouter();
    const [userInputEmail, setInputEmail] = useAtom(userInputEmailAtom);
    // const creditScreenStrapiData = entireStrapiData?.StudioHeaderText?.StudioHeaderText?.CreditScreen;
    
    const { loginPopUp } = router.query;

    useEffect(() => {
        if (loginPopUp) {
            if(user?.user?.login_type === "Guest")setLoginPopupAtom(true);
            const newQuery = { ...router.query };
            delete newQuery?.loginPopUp;
            router.replace({ pathname: router.pathname, query: newQuery }, undefined, { shallow: true });
        }
        else{
            if (!isAuthenticated && email?.length > 0) {
                setInputEmail(email);
                setLoginPopupAtom(true);
            } else {
                setLoginPopupAtom(false);
            }
        }
    }, [searchParams, loginPopUp, isAuthenticated, user]);

    const onBookADemo = () => {
        window.open('https://www.domyshoot.com/bookAdemo?source=website', "_blank") 
    }

    const downloadApp = () => {
        setIsGetAppPopUpOpen(true)
    }
    
    const onLoginHandler = () => {
        setLoginPopupAtom(true);
        if(Object.keys(getSegmentPayloadAtom).length)TrackWebappEvent(`${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._click_login_hp}`,getSegmentPayloadAtom);
    };

    const toggleHelp=()=>{setHelp(x=>!x)}

    useEffect(()=>{
        getNotification();
    },[notification]);
       
    const getNotification = async () => {
        const data = await API_SERVICE.get(`${process.env.NEXT_PUBLIC_API_URL_V2}v1/api/chat/getRecentTicket/0/25/?userId=${get( user,["user", "_id"],  "" )}`);
        const totalUserCount = data.data?.data?.reduce( (sum, item) => sum + +item.unreadChatCount, 0);
        const genericData = await API_SERVICE.get( `${process.env.NEXT_PUBLIC_API_URL_V2}v1/api/chat/getExternalChatUnreadCount`);
        const genericChatCount = genericData.data?.data?.genericChat;
        setNotification(+totalUserCount + genericChatCount);
    };

    const onGoUpgradePlan = () => {
        router.push('/dashboard/setting?tab=PAY_PER_USE');
    };

    return <><ErrorBoundary name={'HeaderSection'}>
    <div className={styles.header}>
    <ErrorBoundary name={'HeaderLogo'}>
        <div className={styles?.headerDiv}>
            <img src={webStrapiData?.WebAppDresmaIconLogo ? webStrapiData?.WebAppDresmaIconLogo : ICONS.onlyLogo} width="35" height="35" className={styles.logoStyle}/>
            {user?.user?.infoGraphicsUser && <InfographicsSelector />}
        </div>
        </ErrorBoundary>
        <ErrorBoundary name={'HeaderButton'}>
        <div className={styles?.headerDiv}>
        <ErrorBoundary name={'DownloadApp'}>
            <div className={`${styles.buttonGrey} user-selection-disable`} onClick={downloadApp}>
                <Phone />
                {strapiData?.getApp || "Download the App" }
            </div>
            </ErrorBoundary>
            
            <ErrorBoundary name={'Notification'}>
            {typeof user?.entity?.entity?.credits === "number" && !isNaN(user?.entity?.entity?.credits) && user?.user?.login_type !== "Guest" && (
            <CustomizedButton
                startIcon={ICONS.creditsViolet}
                btnText={`${user?.entity?.entity?.credits} ${
                user?.entity?.entity?.credits === 1
                    ? strapiData?.CreditScreen?.creditScreenStrapiData?.OnlyCreditText || "Credit"
                    : strapiData?.CreditScreen?.creditScreenStrapiData?.CreditHeading || "Credits"
                }`}
                btnStyle={styledObject.creditsButton}
                onClick={onGoUpgradePlan}
            />
            )}
            <div className={`${styles.buttonRound} user-selection-disable`} onClick={toggleHelp}>
                <Help />
                {(user?.user?.login_type !== "Guest" && notification > 0 )&& 
                <Badge
                badgeContent={notification}  
                color="primary"
                overlap="circular"
                sx={styledObject.badge}
                />
                }
            </div>
            {user?.user?._id ? user?.user?.user_role?.name !== 'APP_USER' ? (isAuthenticated && user?.user?.login_type !== "Guest") 
                ? <div className={`${styles.buttonAccountPopOver} user-selection-disable`}> <AccountPopover /> </div> 
                : <div className={`${styles.buttonGradient} user-selection-disable`} onClick={onLoginHandler}>
                    {strapiData?.getfreepremium || "Log in"}
                </div>
                : <div className={`${styles.buttonGradient} ${styles.notAllowed}`}>
                    <Loader type='lightest' style={{margin: '2px 10px', cursor: 'not-allowed !important'}} />
                    </div>:<div className={styles.buttonGradient} onClick={onLoginHandler}>
                    {strapiData?.getfreepremium || "Log in"}
                </div>
            }
            </ErrorBoundary>
             
            
        
        </div>
        </ErrorBoundary>

        <GetAppLinkByScan open={isGetAppPopUpOpen} onClose={() => setIsGetAppPopUpOpen(false)}/>
       
    </div>
    {help && <NeedHelp getNotification={getNotification} handleClose={toggleHelp}/>}
    </ErrorBoundary>
    </>
}

const styledObject = {
    badge:{position:'absolute',top:3,right:0},
    creditsButton: {
        color: "#5f2ee5",
        background: "RGB(255 234 255)",
        padding:"5px",
        borderRadius:"4px",
        marginLeft:"16px",
        height:"35px"
    }
}